<template>
  <div class="onboarding-layout">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'LayoutOnboarding'
}
</script>

<style scoped>
.onboarding-layout {
  min-height: 100vh;
}
</style>
